// extracted by mini-css-extract-plugin
export default {"calendar":"InstanceSection_calendar__2gp+a","active":"InstanceSection_active__xD51g","calendarBody":"InstanceSection_calendarBody__je8rc"};